import { Component, DestroyRef, HostListener, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { NotificationComponent } from "./_shared_components/notification/notification.component";
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { NotificationType } from '../shared/constants/types';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, Observable, Subject } from 'rxjs';
import { NotificationService } from './_services/app/notification.service';
import { LoadingService } from './_services/app/loading.service';
import { HeaderComponent } from './pages-struct/header/header.component';
import { FooterComponent } from './pages-struct/footer/footer.component';
import { environment } from '../environments/environment';
import { ScrollToTopComponent } from "./_shared_components/scroll-to-top/scroll-to-top.component";
import { UserProfileService } from './_services/app/profile.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, NotificationComponent, HeaderComponent, FooterComponent, ScrollToTopComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit{
  appTitle = environment.appTitle || 'Farco';
  pageTitle: string = '';
  notification: { type: NotificationType, message: string } = { type: null , message: '' };
  postalCode: string = '';
  showLocationModal = false;
  isMobile = false;

  fixedHeader: string[] = ['Accueil'];

  private destroy$ = new Subject<void>();

  constructor(
    private router: Router, 
    private destroyRef: DestroyRef,
    private profileService: UserProfileService,
    private notificationService: NotificationService, 
    public loadingService: LoadingService,
    @Inject(PLATFORM_ID) private platformId: Object
  ){}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.checkScreenSize();    
      setTimeout(() => {
        this.loadingService.hide();
      }, 900);
    }
    this.profileService.syncAcrossTabs();
    this.setupPageTitle();
    this.setupNotifications();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    if (isPlatformBrowser(this.platformId)) {
      this.checkScreenSize();
    }
  }

  checkScreenSize() {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth <= 768;
    }
  }  

  setupPageTitle() {
    if (isPlatformBrowser(this.platformId)) {
    this.router.events.pipe(
      takeUntilDestroyed(this.destroyRef),
      filter(event => event instanceof NavigationEnd),
    ).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.pageTitle = this.getPageTitle(this.router.routerState, this.router.routerState.root);
         
          document.title = this.pageTitle ? `${this.pageTitle} | ${this.appTitle}` : this.appTitle;
         
      }
    });
    }
  }

  getPageTitle(state: any, parent: any): string {
    let data = '';
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data += parent.snapshot.data.title;
    }
    if (state && parent) {
      data += this.getPageTitle(state, state.firstChild(parent));
    }
    return data;
  }

  setupNotifications() {
    this.notificationService.getNotificationSubject().pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(notification => {
      this.notification = notification;
      setTimeout(() => this.notification = { type: null, message: '' }, 5000);
    });
  }

  shouldFixHeader(): boolean {
    return this.fixedHeader.includes(this.pageTitle);
  }

  isHomePage(): boolean {
    const currentRoute = this.router.url;
    return currentRoute === '/home' || currentRoute === '/';
  }
}